import React from 'react';

import { Text } from '@adsk/alloy-react-box';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useUserData } from '../../hooks';
import { useTranslation } from '../../i18n';

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

interface AssigneeCellProps {
  userId: string;
  stacked?: boolean;
  size?: SIZES;
}

const AssigneeDisplay: React.FC<AssigneeCellProps> = ({
  userId,
  stacked = false,
  size = SIZES.MEDIUM,
}) => {
  const { t } = useTranslation();
  const user = useUserData(userId);

  const typographyType = size === SIZES.SMALL ? 'bodySmall' : 'bodyMedium';

  if (!user.name) {
    if (user.isLoading) {
      return <span>{t('LOADING')}</span>;
    } else {
      return <Text color="charcoal500">{t('FORMER_MEMBER')}</Text>;
    }
  }

  const { name, company } = user;

  const tooltipContent = (
    <div>
      <div>{name}</div>
      <div>{company}</div>
    </div>
  );
  return (
    <OverflowTooltip content={tooltipContent} autoTipOnEllipsis>
      <Text typography={typographyType}>{name}</Text>
      {company &&
        (stacked ? (
          <>
            <br />
            <Text color="charcoal700" typography={typographyType}>
              {company}
            </Text>
          </>
        ) : (
          <Text marginLeft="4px" typography={typographyType}>
            ({company})
          </Text>
        ))}
    </OverflowTooltip>
  );
};

AssigneeDisplay.displayName = 'SubmittalsAssigneeDisplay';

export default AssigneeDisplay;
